module.exports = __webpack_public_path__ + "static/media/ic_clear_white_24px.ee52d25f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/CloseButton/ic_clear_white_24px.svg
// module id = 1015
// module chunks = 2